import React, { Component } from 'react';
import { styled } from '@mui/material/styles';
import Timeline from './source/src/index.jsx';

import 'react-timelines/lib/css/style.css';

import { START_YEAR, NUM_OF_YEARS, MIN_ZOOM, MAX_ZOOM, DEFAULT_ZOOM } from './constants';
import { buildTimebar, buildTrack } from './builders';
import { fill } from './utils';

const StyledGantt = styled('div')({
  border: '1px solid black',
});

const now = new Date();
const timebar = buildTimebar();

class ProjectDetailGantt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      zoom: DEFAULT_ZOOM,
    };
  }

  render() {
    const { data, multiply_by_sfdc_probability, editMode, assignmentEdits, setAssignmentEdits, pmResourceNames, profile_data } = this.props;
    const { zoom } = this.state;

    const tracks = fill(data.length).map((_, i) => 
      buildTrack(i + 1, data[i], multiply_by_sfdc_probability)
    );

    const start = new Date(START_YEAR.toString());
    const end = new Date((START_YEAR + NUM_OF_YEARS).toString());

    return (
      <StyledGantt>
        <Timeline
          scale={{
            start,
            end,
            zoom,
            zoomMin: MIN_ZOOM,
            zoomMax: MAX_ZOOM,
          }}
          timebar={timebar}
          tracks={tracks}
          now={now}
          enableSticky
          scrollToNow
          editMode={editMode}
          assignmentEdits={assignmentEdits}
          setAssignmentEdits={setAssignmentEdits}
          pmResourceNames={pmResourceNames}
          profile_data={profile_data}
        />
      </StyledGantt>
    );
  }
}

export default ProjectDetailGantt;
